export default __webpack_public_path__ + "5a717a1fba0c5c93e786012328aa91f3.png";